import withStyles from "react-jss"
import colors from "../styles/colors"
import { TRANSITION_DURATION } from "../styles/globalStyles"
import audioWave from "../assets/images/audio-wave.gif"

const styles = {
  overflow: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    overflowY: "hidden",
  },
  container: {
    position: "relative",
    height: "100%",
  },
  opacityTransition: {
    transition: `opacity ${TRANSITION_DURATION} ease-in`,
  },
  line: {
    position: "absolute",
    top: 0,
    left: "calc(50% - 2.5px)",
    width: "5px",
    height: "100%",
    background: colors.black,
    composes: "$opacityTransition",
  },
  waveBg: {
    height: "100%",
    width: ({ width }) => (width ? width : "30px"),
    background: `url(${audioWave})`,
    backgroundRepeat: "repeat-y",
    backgroundSize: "cover",
    opacity: 0,
    composes: "$opacityTransition",
  },
}

const Sidebar = ({ classes, playing }) => {
  return (
    <div className={classes.overflow}>
      <div className={classes.container}>
        <div className={classes.line} style={{ opacity: playing ? 0 : 1 }} />
        <div className={classes.waveBg} style={{ opacity: playing ? 1 : 0 }} />
      </div>
    </div>
  )
}

export default withStyles(styles)(Sidebar)
